import React from 'react'
import { Text } from '@bbl-digital/snorre'
import { Wrapper } from './styles'

interface IProps {
  text: string
  illustration?: React.ReactNode
  hasSearch?: boolean
  className?: string
}

const NoResults: React.FC<IProps> = ({
  text,
  hasSearch,
  illustration,
  className,
}) => {
  const msg = (hasSearch && 'Ditt søk ga ingen treff') || text

  return (
    <Wrapper withIllustration={!!illustration} className={className}>
      {illustration && illustration}
      <Text align="center" semibold>
        {msg}
      </Text>
    </Wrapper>
  )
}

export default NoResults
